<div class="md:_container _mx-auto _min-h-80vh" [ngClass]="loading ? '_h-full' : '_h-auto'">
    <div class="_flex _justify-end _py-3 _border-b _border-transparency-black-5 _shadow-bottom _sticky _top-0 _bg-white _z-10">
        <i class="fa-sharp fa-solid fa-circle-xmark _cursor-pointer _text-h3-m" mat-dialog-close></i>
    </div>
    <app-loading-spinner [show]="loading"></app-loading-spinner>
    <div class="_mt-10">
        <div id="gallery" class="gallery">
            <div class="image-wrapper _overflow-hidden _w-full _h-auto" *ngFor="let photo of album; let i=index;">
                <img app-imagekit 
                    [source]="photo.thumb"
                    (click)="open(i)"
                    (load)="onImageLoad($event)">
            </div>
        </div>
    </div>
</div>
